import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { mediaLabelDriverFactory } from './MediaLabel.driver';
import { MediaLabel, MediaLabelProps } from '.';
import { VideoFill } from '@wix/wix-ui-icons-common/on-stage';

describe('MediaLabel', () => {
  const createDriver = createRendererWithUniDriver(mediaLabelDriverFactory);

  const bootstrap = (props: Partial<MediaLabelProps> = {}) => {
    return createDriver(
      <MediaLabel text="14:30" icon={<VideoFill />} {...props} />,
    );
  };

  it('should render', async () => {
    const { driver } = bootstrap();
    expect(await driver.exists()).toBe(true);
  });
  it('should have an icon', async () => {
    const { driver } = bootstrap();
    expect(await driver.hasIcon()).toBe(true);
  });
  it('should have text', async () => {
    const { driver } = bootstrap();
    expect(await driver.hasText()).toBe(true);
  });
  it('should set the correct text', async () => {
    const { driver } = bootstrap();
    expect(await driver.getText()).toBe('14:30');
  });
});
